import {
    timestampSLVWithHeaders,
    scheduleTime,
    timestamp,
    timestampUnread,
    timestampUnreadPinnedItem,
    secondRowThreeColumnRead,
    cfPreviewStamp,
} from 'owa-mail-listitem-styles/lib/scss/MailListItem.scss';

import classnames from 'owa-classnames';
import { observer } from 'owa-mobx-react';
import { useMessageListTextStyle } from 'owa-mail-listitem-styles/lib/utils/useMessageListTextStyle';
import type { OwaDate } from 'owa-datetime';
import {
    type ConditionalFormattingModification,
    getConditionalFormattingStyles,
    ConditionalFormattingSurface,
} from 'owa-conditional-formatting';
import { formatRelativeDateForMailListRow } from 'owa-mail-list-item-shared';
import React from 'react';

export interface MailListItemTimestampProps {
    isPinned: boolean;
    isSnoozed?: boolean;
    isSingleLine?: boolean;
    isUnread?: boolean;
    lastDeliveryTimestamp?: string;
    returnTime: string;
    supportsPinning: boolean;
    isCfPreview: boolean;
    isDarkTheme: boolean;
    conditionalFormattingModifications?: ConditionalFormattingModification[];
    isSelected?: boolean;
}

const defaultExport: React.FunctionComponent<MailListItemTimestampProps> = observer(
    function MailListItemTimestamp(props: MailListItemTimestampProps) {
        const {
            isPinned,
            isSnoozed = false,
            isSingleLine = false,
            isUnread = false,
            lastDeliveryTimestamp = '',
            returnTime,
            supportsPinning,
            isCfPreview,
            conditionalFormattingModifications,
            isDarkTheme,
            isSelected = false,
        } = props;

        const timestampConditionalFormattingStyles = React.useMemo(() => {
            const conditionalFormattingStyles =
                conditionalFormattingModifications && conditionalFormattingModifications.length > 0
                    ? getConditionalFormattingStyles(
                          ConditionalFormattingSurface.Text,
                          conditionalFormattingModifications,
                          isDarkTheme,
                          isSelected
                      )
                    : undefined;

            return conditionalFormattingStyles;
        }, [conditionalFormattingModifications, isDarkTheme, isSelected]);

        // shared styles
        let timestampStyles = classnames(
            isSingleLine ? timestampSLVWithHeaders : undefined,
            useMessageListTextStyle('Minor')
        );

        let tooltipText: string = '';
        let formattedDate: string = '';

        let timestampToFormat: OwaDate | string | null | undefined = null;

        if (isSnoozed) {
            if (!returnTime) {
                return null;
            }
            timestampToFormat = returnTime;

            // apply snoozed item timestamp specific styles
            timestampStyles = classnames(timestampStyles, scheduleTime);
        } else {
            if (returnTime) {
                return null;
            }
            timestampToFormat = lastDeliveryTimestamp;

            timestampStyles = classnames(
                timestampStyles,
                timestamp,
                isUnread && timestampUnread,
                isUnread && supportsPinning && isPinned && timestampUnreadPinnedItem,
                !isUnread && secondRowThreeColumnRead
            );
        }

        if (timestampToFormat) {
            const dateFormats = formatRelativeDateForMailListRow(timestampToFormat);
            formattedDate = dateFormats.displayText;
            tooltipText = dateFormats.tooltipText;
        }
        return (
            <span
                className={classnames(timestampStyles, isCfPreview && cfPreviewStamp)}
                title={tooltipText}
                style={timestampConditionalFormattingStyles}
            >
                {formattedDate}
            </span>
        );
    },
    'MailListItemTimestamp'
);
export default defaultExport;
